import React from 'react';

function DevelopmentInfoCard({
  developmentRails = [],
  railVisibleCount = 6,
  railLoadingMore = false,
  onLoadMoreRail,
  developmentJigus = [],
  jiguVisibleCount = 6,
  jiguLoadingMore = false,
  onLoadMoreJigu,
}) {
  return (
    <section className="overview-card fixed-height-card">
      <h3>{'\uAC1C\uBC1C\uAD6C\uC5ED \uC815\uBCF4'}</h3>
      <div className="sub-title">{'\uAC1C\uBC1C \uCCA0\uB3C4'}</div>
      {developmentRails.length ? (
        <>
          <div className="card-list-scroll">
            <ul className="bullet-list">
              {developmentRails.slice(0, railVisibleCount).map((item, idx) => (
                <li key={`rail-${idx}`}>
                  {item.stationName || '-'} {' · '} {item.railName || '-'} {' · '} {item.openDate || '-'}
                  {item.distance ? ` · ${item.distance.toLocaleString()}m` : ''}
                </li>
              ))}
            </ul>
          </div>
          {developmentRails.length > railVisibleCount ? (
            <button type="button" className="more-btn" onClick={onLoadMoreRail} disabled={railLoadingMore}>
              {railLoadingMore ? '\uB85C\uB529 \uC911..' : '\uB354\uBCF4\uAE30'}
            </button>
          ) : null}
        </>
      ) : (
        <p className="empty-mini">{'\uB370\uC774\uD130 \uC5C6\uC74C'}</p>
      )}

      <div className="sub-title">{'\uC9C0\uAD6C\uB2E8\uC704\uACC4\uD68D'}</div>
      {developmentJigus.length ? (
        <>
          <div className="card-list-scroll">
            <ul className="bullet-list">
              {developmentJigus.slice(0, jiguVisibleCount).map((item, idx) => (
                <li key={`jigu-${idx}`}>{item.name || '-'} {' · '} {item.typeName || '-'} {' · '} {item.step || '-'}</li>
              ))}
            </ul>
          </div>
          {developmentJigus.length > jiguVisibleCount ? (
            <button type="button" className="more-btn" onClick={onLoadMoreJigu} disabled={jiguLoadingMore}>
              {jiguLoadingMore ? '\uB85C\uB529 \uC911..' : '\uB354\uBCF4\uAE30'}
            </button>
          ) : null}
        </>
      ) : (
        <p className="empty-mini">{'\uB370\uC774\uD130 \uC5C6\uC74C'}</p>
      )}
    </section>
  );
}

export default DevelopmentInfoCard;
